type LicenseErrorBody = {
  error?: string
  feature_key?: string
  license_status?: string
  license_plan?: string
  reason?: string
  code?: string
}

const featureLabels: Record<string, string> = {
  technology_management: "zarzadzanie technologiami",
  advanced_reports: "raporty rozszerzone",
  inventory_count: "modul inwentaryzacji",
  production_orders: "zlecenia produkcyjne",
  auto_replenishment: "automatyczne uzupełnianie",
  operational_analytics: "analityka operacyjna",
  product_labels: "etykiety produktów",
  ksef_integration: "integracja KSeF",
}

const statusLabels: Record<string, string> = {
  active: "aktywna",
  unlicensed: "brak aktywnej licencji",
  expired_grace: "wygasla, ale nadal znajduje sie w okresie grace",
  expired_limited: "wygasla z ograniczonym dostepem",
  expired_critical: "wygasla w trybie krytycznym",
  suspended: "zawieszona administracyjnie",
  revoked: "zostala cofnięta przez dostawce",
}

function readLicenseErrorBody(error: any): LicenseErrorBody | null {
  const body = error?.body
  if (!body || typeof body !== "object") return null
  if (
    body.error !== "feature is disabled by license policy" &&
    body.error !== "license module is unavailable"
  )
    return null
  return body as LicenseErrorBody
}

export function getLicenseErrorDetails(error: any): {
  title: string
  description: string
} | null {
  const body = readLicenseErrorBody(error)
  if (!body) return null

  const featureLabel = featureLabels[body.feature_key ?? ""] ?? "ta funkcja WMS"
  const statusLabel = statusLabels[body.license_status ?? ""] ?? "nieaktywna"

  if (
    body.reason === "plan_excluded" ||
    body.code === "LICENSE_PLAN_NOT_ALLOWED"
  ) {
    return {
      title: "Funkcja niedostępna w planie",
      description: `Plan ${body.license_plan ?? "BASIC"} nie obejmuje ${featureLabel}.`,
    }
  }
  if (body.reason === "license_override") {
    return {
      title: "Moduł wyłączony dla tej licencji",
      description: `${featureLabel} został wyłączony w ustawieniach tej licencji. Administrator może go włączyć, jeśli obejmuje go plan.`,
    }
  }
  if (body.reason === "dependency_disabled") {
    return {
      title: "Wymagany moduł jest wyłączony",
      description: `Dla ${featureLabel} administrator musi najpierw włączyć wymagany moduł.`,
    }
  }
  if (body.reason === "invalid_contract") {
    return {
      title: "Nieprawidłowa konfiguracja licencji",
      description:
        "Skontaktuj się z administratorem licencji. Nie można potwierdzić uprawnień do tego modułu.",
    }
  }

  if (
    body.license_status === "revoked" ||
    body.license_status === "suspended"
  ) {
    return {
      title: "Funkcja zablokowana przez licencje",
      description: `Licencja zostala administracyjnie ograniczona (${body.license_status}), dlatego ${featureLabel} jest obecnie niedostepne.`,
    }
  }

  if (body.license_status === "unlicensed") {
    return {
      title: "System nie ma jeszcze aktywnej licencji",
      description: `Nie utworzono jeszcze aktywnej licencji lub installation credentials, dlatego ${featureLabel} jest obecnie niedostepne.`,
    }
  }

  return {
    title: "Funkcja ograniczona przez licencje",
    description: `Biezaca licencja jest w stanie: ${statusLabel}, dlatego ${featureLabel} jest obecnie niedostepne.`,
  }
}
